"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "péntek",
    "MONDAY": "hétfő",
    "SATURDAY": "szombat",
    "SUNDAY": "vasárnap",
    "THURSDAY": "csütörtök",
    "TUESDAY": "kedd",
    "WEDNESDAY": "szerda",
    "and": "és",
    "day": "nap",
    "day_one": "nap",
    "day_other": "napok",
    "day_plural": "napok",
    "freeOfCharge": "Díjmentes",
    "hour_one": "óra",
    "hour_one_plural": "órák",
    "hour_other": "órák",
    "minute": "perc",
    "minute_one": "perc",
    "minute_other": "percek",
    "ocpiRestrictionsAfterDuration": "{{minDuration}} után",
    "ocpiRestrictionsBetweenDuration": "{{minDuration}} és {{maxDuration}} között",
    "ocpiRestrictionsFirstDuration": "Első {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Ha az energiafogyasztás meghaladja a {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Ha az energiafogyasztás {{minKwh}} és {{maxKwh}} között van",
    "ocpiRestrictionsKwhLessThan": "Ha az energiafogyasztás kevesebb, mint {{maxKwh}}",
    "session": "ülés",
    "theDay": "nap",
    "theDay_one": "nap",
    "theDay_other": "napok",
    "theHour": "óra",
    "theHour_one": "óra",
    "theHour_other": "órák",
    "theMinute": "perc",
    "theMinute_one": "perc",
    "theMinute_other": "percek"
};
